import { Group } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { IconCloudUpload, IconUpload, IconX } from '@tabler/icons-react';

import styles from './DocumentDropzone.module.scss';
import { Props } from './DocumentDropzone.types';

const DocumentDropzone = ({ subtitle, title, ...props }: Props) => {
  return (
    <Dropzone maxSize={750 * 1024 ** 2} {...props}>
      <Group justify="center" mih={138} style={{ pointerEvents: 'none' }}>
        <Dropzone.Accept>
          <IconUpload size={52} color="var(--mantine-color-blue-6)" stroke={1.5} />
        </Dropzone.Accept>
        <Dropzone.Reject>
          <IconX size={52} color="var(--mantine-color-red-6)" stroke={1.5} />
        </Dropzone.Reject>
        <Dropzone.Idle>
          <IconCloudUpload size={52} color="var(--mantine-color-dimmed)" stroke={1.5} />
        </Dropzone.Idle>

        <div>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
      </Group>
    </Dropzone>
  );
};

export default DocumentDropzone;
